import { render, staticRenderFns } from "./GetHtmlFile.vue?vue&type=template&id=b48d788c&scoped=true"
import script from "./GetHtmlFile.vue?vue&type=script&lang=js"
export * from "./GetHtmlFile.vue?vue&type=script&lang=js"
import style0 from "./GetHtmlFile.vue?vue&type=style&index=0&id=b48d788c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d788c",
  null
  
)

export default component.exports